import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import debounce from "debounce";


export default class extends Controller {
    static targets = [ "name" ]

    connect() {
    }

    removeCampaign(event) {
        const campaignID = event.currentTarget.id;
        const campaignName = event.currentTarget.dataset.campaignName;
        const removed_campaign = { name: campaignName, id: campaignID };

        let data = new FormData();
        data.append("removed_campaign", JSON.stringify(removed_campaign));

        Rails.ajax({
            url: "/insights/remove_campaign_insight_report/",
            type: "POST",
            data: data,
            success: (data, status, xhr) => {
                Turbo.renderStreamMessage(xhr.responseText);
            },
            error: (err) => console.error("Erreur AJAX:", err)
        });
    }

    sumbitInstanceForm(event) {
        event.preventDefault();
        this.element.closest("form").requestSubmit();
    }

    submitCampaignForm(event) {
        event.preventDefault();
        this.element.closest("form").requestSubmit();
    }
}
